import { render, staticRenderFns } from "./InstitutionAngebotBlock.vue?vue&type=template&id=64cce15c&scoped=true&"
import script from "./InstitutionAngebotBlock.vue?vue&type=script&lang=js&"
export * from "./InstitutionAngebotBlock.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionAngebotBlock.vue?vue&type=style&index=0&id=64cce15c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cce15c",
  null
  
)

export default component.exports